export default __webpack_public_path__ + "static/media/depart_pirate.short.fstart.14a00a0c.mp4";